var _this = this,
  _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB-JOB1/src/components/Divider/Divider.js";
import React from 'react';
import styled from 'styled-components';
import { withTheme } from '../../core/ThemeProvider';
var Divider = function Divider(props) {
  return /*#__PURE__*/React.createElement(HorizontalDivider, {
    "data-testid": props['data-testid'],
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6,
      columnNumber: 10
    }
  });
};
Divider.defaultProps = {};
var HorizontalDivider = withTheme(styled.div.withConfig({
  displayName: "Divider__HorizontalDivider",
  componentId: "sc-1qi29z9-0"
})(["height:1px;background-color:", ";border-radius:1px;"], function (p) {
  return p.coreTheme.cl_divider;
}));
export default Divider;